// extracted by mini-css-extract-plugin
export default {"hasTooltip":"d04b607aa03b0aa096a41a5ae37e188e-scss"};